const useClientApiUrl = () => {
    if (window.location.host.split(".").length === 1) return process.env.REACT_APP_API_BASE_URL;
    if (window.location.host.indexOf("localhost") > -1 || window.location.host.indexOf("127.0.0.1") > -1) {
        let [, subdomain] = window.location.host.split(".").reverse();
        return process.env.REACT_APP_API_BASE_URL.replace("http://", "http://" + subdomain + ".").replace("https://", "https://" + subdomain + ".");
        // return process.env.REACT_APP_API_BASE_URL;
    }

    //let [, , subdomainOnline] = window.location.host.replace("www.", "").split(".").reverse();

    // if(subdomainOnline){

    //     subdomainOnline += ".";

    //     if (process.env.REACT_APP_API_BASE_URL.indexOf("www")>-1){
    //         return process.env.REACT_APP_API_BASE_URL.replace("http://www.",`http://www.${  subdomainOnline}`).replace("https://www.",`https://www.${  subdomainOnline}`);
    //     }
    //     return process.env.REACT_APP_API_BASE_URL.replace("http://",`http://${  subdomainOnline}`).replace("https://", `https://${  subdomainOnline}`);
    // }
    return process.env.REACT_APP_API_BASE_URL;

}

export default useClientApiUrl;